/**
 * User: n.gorte
 * Date: 08.04.2019
 * Time: 09:53
 */
'use strict';
import { stateToValueMap } from './feature-util';

const ICONS_PATH = '/o/de.xdot.liferay.map.web/icons/2x/';

const createDefaultIcon = iconUrl => (
    L.Icon.extend({
        options: {
            iconUrl,
            popupAnchor: [ 0, -50 ],
            iconSize: [ 25, 41 ],
            iconAnchor: [ 12, 41 ]
        }
    })
);

const createHighlightIconIcon = iconUrl => (
    L.Icon.extend({
        options: {
            iconUrl,
            popupAnchor: [ 0, -60 ],
            iconSize: [ 35, 58 ],
            iconAnchor: [ 17, 51 ]
        }
    })
);

const keysByClassNameType = {
    'GaugingStation': 'pm',
    'GaugingStation-default': 'pe',
    'GaugingStation-local': 'pm',
    'GaugingStation-automated-local': 'pk',
    'GaugingStation-central': 'pl',
    'FloodRetentionBasin': 'hrb',
    'CriticalObject': 'ko',
    'FloodProtectionObjectLine': 'hsl',
    'FloodProtectionObjectPoint': 'hso',
    'Group': 'kommune',
    'PlannedActionVersion': 'massnahme',
    'Task': 'progress-check',
    'NewsMessage': 'news',
    'DikeBreak': 'dike_break_b',
    'DikeBreak-breachPoint': 'dike_break_b',
    'DikeBreak-reliefPoint': 'dike_break_be',
    'PrecipitationStation': 'np',
    'RealPrecipitationStation': 'nr',
    'PrecipitationStation-point': 'np',
    'PrecipitationStation-area': 'nf',
    'Quarter': 'tg',
    'ManualBooleanState': 'mbs'
};


const iconCache = { h: {}, d: {} };

export function boIcon(className, typeKey, highlight, state) {
    const key = keysByClassNameType[className + (typeKey ? ('-' + typeKey) : '')] || keysByClassNameType[className];
    const path = ICONS_PATH + key + (state ? '_warn-level-' + stateToValueMap[state] : '') + '@2x.png';
    const cache = iconCache[ highlight ? 'h' : 'd' ];

    return cache[ path ] || (cache[ path ] = new (highlight ? createHighlightIconIcon(path) : createDefaultIcon(path)));
}



// WEBPACK FOOTER //
// ./js/utils/icons.js